import type { Atom } from "jotai";

export const capitalizeFirstLetter = (str = "") =>
  str.length > 0 ? str[0]?.toUpperCase() + str.slice(1) : "";
export const getProviderIndex = (name = "") =>
  `${capitalizeFirstLetter(name)}Provider`;
export const getStoreIndex = (name = "") =>
  name.length > 0 ? `${name}Store` : "store";
export const getUseStoreIndex = (name = "") =>
  `use${capitalizeFirstLetter(name)}Store`;
export const getUseOptionalStoreIndex = (name = "") =>
  `useOptional${capitalizeFirstLetter(name)}Store`;
export const getConsumerIndex = (name = "") =>
  `${capitalizeFirstLetter(name)}Consumer`;

export const isAtom = (possibleAtom: unknown): possibleAtom is Atom<any> =>
  !!possibleAtom &&
  typeof possibleAtom === "object" &&
  "read" in possibleAtom &&
  typeof possibleAtom.read === "function";
